module.exports = __webpack_public_path__ + "static/ishi-mobile-bg-4f1ab989432e6640c627771cae5de7db.png";